"use strict";

import * as CartPage from "components/CartPage";
document.addEventListener("DOMContentLoaded", function () {
  CartPage.init();
});
